module.exports = __webpack_public_path__ + "img/workbench_upload1.cd77d1f8.svg";